import { useMutation, useQueryClient } from "@tanstack/react-query";
import { changeTopupCard } from "@/api/campaignCard";

/**
 * Changing the card IS the retry — so everything that shows a campaign's funding state is stale the
 * moment this resolves: the attention strip, the campaign list's badge, the card list.
 */
export function useChangeTopupCard(campaignId: number) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (paymentMethodId: number) => changeTopupCard(campaignId, paymentMethodId),
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: ["topups", "attention"] });
      queryClient.invalidateQueries({ queryKey: ["campaigns"] });
    },
  });
}
